import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import {
  IAPIFundingDetailPageResponseModel,
  IAPIFundingPayoutsGridModel,
  IAPIFundingSummaryResponseModel,
} from "../interfaces/IAPIFundingPayoutsModel";

class FundingService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }
  getPayouts(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIFundingPayoutsGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIFundingPayoutsGridModel[]>>(
      url.getPayouts,
      params
    );
  }

  getFundings(
    accountId: string
  ): Observable<IAPIResponse<IAPIFundingSummaryResponseModel>> {
    const params: string = buildParamString({
      accountId: accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIFundingSummaryResponseModel>>(
      url.getFundings,
      params
    );
  }

  getPayoutDetails(
    accountId: string,
    merchantAccountId: string,
    payoutId: string
  ): Observable<IAPIResponse<IAPIFundingDetailPageResponseModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      merchantAccountId: merchantAccountId,
      payoutId: payoutId,
    });
    return this.httpService.get<
      IAPIResponse<IAPIFundingDetailPageResponseModel>
    >(url.getPayoutDetails, params);
  }
}
export default new FundingService();
